import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class NewfolderService {

  constructor(private http: HttpClient, private globalService: GlobalService) { }

  getGroups(token) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGroupsURL, httpOptions)
  }

  newGroup(token, obj) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.newGroupURL, obj, httpOptions)
  }

  newFolder(token, parentF, folderN) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.newFolder(parentF, folderN), httpOptions)
  }

  setPermission(token, obj, id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.put<any>(this.globalService.setNodePermission(id), obj, httpOptions)
  }


  getCustomer(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getCustomer, httpOptions)
  }

  getPermission(token, id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getNodePermission(id), httpOptions)
  }

  updateNameFolder(token, id, name){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.put<any>(this.globalService.updateFolderName(id), name, httpOptions)
  }

  delFolder(token, id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.deleteFolder(id), httpOptions)
  }

  // updateGroup(token, obj){
  //   let httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Authorization': token
  //     })
  //   };
  //   return this.http.put<any>(this.globalService.updateGroup(obj), httpOptions)
  // }

}
